import { service } from '@/request/server'

// 管理员列表
export const adminList = (params) => (
  service({
    url: '/Admin/adminList',
    method: 'GET',
    params
  })
)

// 管理员详情
export const adminInfo = (params) => (
  service({
    url: '/Admin/adminInfo',
    method: 'GET',
    params
  })
)

// 修改保存管理员信息
export const saveAdminInfo = (params) => (
  service({
    url: '/Admin/saveAdminInfo',
    method: 'POST',
    data: params
  })
)

// 修改管理员密码
export const changePwd = (params) => (
  service({
    url: '/Admin/changePwd',
    method: 'POST',
    data: params
  })
)